// from '@paperbits/common/utils'; extracted to avoid import cascade
// from '@paperbits/common/utils'; extracted to avoid import cascade
export default function identifier(startWithLetter: boolean = false): string {
    let result = '';
    const lettersBound = 52;
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < 5; i++) {
        const possibleLength = (startWithLetter && i === 0) ? lettersBound : possible.length;
        result += possible.charAt(Math.floor(Math.random() * possibleLength));
    }

    return result;
}